import { gql } from '@apollo/client';

export const GET_CONTRACT_LOCATIONS = gql`
  query GetContractLocations($filter: palmoil_transport_crew_contract_bool_exp) {
    palmoil_transport_crew_contract(where: $filter, limit: 100) {
      id
      status
      market_day
      buyer_organisation {
        id
        name
      }
      seller_transactor {
        id
        person {
          id
          full_name
        }
      }
      harvest_price_contract_bundles {
        id
        harvest_bundle {
          id
          land_plot {
            id
            address_text
            latitude
            longitude
          }
        }
      }
    }
  }
`;
